<template>
	<div class="heading">
		<template v-if="block.content && block.content.level == 'h1'">
			<h1 v-html="block.content.text"></h1>
		</template>
		<template v-if="block.content && block.content.level == 'h2'">
			<h2 v-html="block.content.text"></h2>
		</template>
		<template v-if="block.content && block.content.level == 'h3'">
			<h3 v-html="block.content.text"></h3>
		</template>
		<template v-if="block.content && block.content.level == 'h4'">
			<h4 v-html="block.content.text"></h4>
		</template>
	</div>
</template>

<script>

import scrollBehavior  from '@/mixins/scrollBehavior.js'
import loaderHandler  from '@/mixins/loaderHandler.js'

export default {
	mixins: [scrollBehavior, loaderHandler],
	props: ['block','currentLang'],
}
</script>

<style lang="scss">
	.heading{
		max-width:1200px;
		margin:auto;
		padding: 2em 0;
		@media screen and (min-width: 1024px){
			padding-bottom:2.2222em;
		}
		h1, h2, h3{
			font-family: 'surtbold_extended', Helvetica, Arial, sans-serif;
		}

		h1{
			font-size: 2.333em;
			line-height:1.4;
		}

		h2{
			font-size: 1.75em;
			line-height:1.4;
		}

		h3{
			font-size: 1.3333em;
		}
		h4, h5, h6{
			font-size: 1em;
		}
		@media screen and (max-width: 768px){
			h1{
				font-size: 1.6rem;
				line-height: 2.2rem;
			}
			h2{
				font-size: 1.2rem;
				line-height: 2rem;
			}
		}
	}

	.bloc--regular .heading{
		max-width:850px;
	}

	@media screen and (min-width:1024px){
		.bloc--fullWidth .w_100 .heading{
			padding: 5.33333em 0 2.22222em 0;
		}
		.bloc--fullWidth .w_100 .heading + .heading{
			padding-top: 0;
		}

		.bloc--fullWidth .w_33 .heading{
			padding:3.33333em;
			padding-bottom: 2.22222em;
		}
		.bloc--fullWidth .w_66 .heading,
		.bloc--fullWidth .w_50 .heading{
			padding: 5.33333em;
			padding-bottom: 2.22222em;
		}
		// .bloc--fullWidth .w_66:first-child .heading,
  //     	.bloc--fullWidth .w_50:first-child .heading{
  //   		padding-right:3.33333em;
  //   	}
  //   	.bloc--fullWidth .w_66:last-child .heading,
  //   	.bloc--fullWidth .w_50:last-child .heading{
  //   		padding-left:3.33333em;
  //   	}
	}

	@media screen and (max-width:1024px){
		.bloc--fullWidth .heading{
			padding: 2em;
		}
	}
   
</style>